import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getEditorialTeamProofsByOwnerOptions } from '@/module/Author/EditorialTeam/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface EditorialTeamOwnerProofListProps {
  editorialTeamId: Id;
  userId: Id;
}

export function EditorialTeamOwnerProofList({ editorialTeamId, userId }: EditorialTeamOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getEditorialTeamProofsByOwnerOptions(editorialTeamId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="editorial-team"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
